import {FlatList, Image, Text, TouchableOpacity, View} from 'react-native';
import React from 'react';
import {Subject} from '../../../../store/xueke';
import {createStyles} from '../../../../utils/createStyles';
interface SubjectListProps {
  subjects: Subject[];
  changeSubject: (id: number) => void;
  currentSubjectId: number;
}

const imageSeparator = () => (
  <View style={styles.imageSeparator}>
    <Text>|</Text>
  </View>
);
const SubjectList: React.FC<SubjectListProps> = ({
  subjects,
  changeSubject,
  currentSubjectId,
}) => {
  return (
    <View>
      <FlatList
        data={subjects}
        renderItem={({item}) => {
          return (
            <TouchableOpacity
              activeOpacity={1}
              onPress={() => changeSubject(item.id)}
              style={styles.SynchroWorkbookBoxTopItem}>
              <Text
                style={[
                  styles.SynchroWorkbookBoxTopItemText,
                  item.id === currentSubjectId &&
                    styles.SynchroWorkbookBoxTopItemTextActive,
                ]}>
                {item.name}
              </Text>
              {item.id === currentSubjectId && (
                <Image
                  style={styles.SynchroWorkbookBoxTopItemLine}
                  source={{
                    uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/swk_line.png',
                  }}
                />
              )}
            </TouchableOpacity>
          );
        }}
        ItemSeparatorComponent={imageSeparator}
        horizontal={true} // 设置为横向展示
      />
    </View>
  );
};
const styles = createStyles({
  SynchroWorkbookBoxTop: {
    flexDirection: 'row',
  },
  SynchroWorkbookBoxTopItem: {
    minWidth: '12.2rem',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: '1.2rem',
    paddingHorizontal: '1.5rem',
  },
  SynchroWorkbookBoxTopItemText: {
    fontSize: '1.6rem',
    color: '#7D7A95',
  },
  SynchroWorkbookBoxTopItemTextActive: {
    zIndex: 2,
    color: '#6658FF',
    fontSize: '1.9rem',
    fontWeight: 'bold',
  },
  SynchroWorkbookBoxTopItemLine: {
    zIndex: 1,
    marginTop: '-1.2rem',
    width: '5.7rem',
    height: '1.25rem',
  },
  imageSeparator: {
    // width: '1rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
export default SubjectList;
